import { FC } from "react";
import { Typography } from "@mui/material";
import { OutlinedPaper } from "../../../components/OutlinedPaper";
import { Skeleton } from "../../../components/loading";
import { CompanyTypeFilterChip } from "../CompanyTypeFilterChip/CompanyTypeFilterChip";

interface ProductPageHeaderProps {
  productName: string;
  isLoading: boolean;
}

export const ProductHeader: FC<ProductPageHeaderProps> = (props) => {
  return (
    <OutlinedPaper
      id="product-header-card"
      sx={{
        display: "flex",
        padding: "14px",
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      <Skeleton isLoading={props.isLoading} width={180} height={38}>
        <Typography variant="h1" data-testid="catalog-product-title">
          {props.productName}
        </Typography>
      </Skeleton>

      <CompanyTypeFilterChip />
    </OutlinedPaper>
  );
};
